<div class="course-list-container">

    <!-- Header Section -->
    <div class="content-section">
        <div class="title">Sample Courses</div>
        <div class="sub-title">An overview of all your sample courses!</div>
    </div>

    <!-- List of courses space -->
    <div class="topic-section" *ngIf="!isLoading">
        <div class="topics" *ngIf="selectedTopic == 'all'">
            <ng-container *ngFor="let category of categories">
                <app-category *ngIf="courses[category]" [category]="category"
                    [courseList]="courses[category]"></app-category>
            </ng-container>
        </div>
        <app-category *ngIf="selectedTopic !== 'all'" [courseList]="courses[selectedTopic]"
            [category]="selectedTopic"></app-category>
    </div>
    <div class="spinner-icon" *ngIf="isLoading">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <label for="">Loading</label>
    </div>
</div>